/**
 * Page-wide exclusive hover-video lock.
 * Safari iOS struggles with multiple <video> elements decoding at once.
 * When one card starts hover-play, every other registered player is paused
 * (and unloaded via the player's unloadVideoOnPaused behavior).
 */

type PauseFn = () => void;

const players = new Map<string, PauseFn>();
let activePlayerId: string | null = null;

export function registerExclusiveHoverVideo(
  id: string,
  pause: PauseFn
): () => void {
  players.set(id, pause);
  return () => {
    players.delete(id);
    if (activePlayerId === id) {
      activePlayerId = null;
    }
  };
}

/** Pause/unload every other registered player, then mark this one active. */
export function claimExclusiveHoverVideo(id: string): void {
  activePlayerId = id;
  players.forEach((pause, playerId) => {
    if (playerId !== id) {
      pause();
    }
  });
}

export function releaseExclusiveHoverVideo(id: string): void {
  if (activePlayerId === id) {
    activePlayerId = null;
  }
}
